import { gql } from 'apollo-angular';

export const GET_JOB_REF_ID_BY_SMART_CONTRACT_ID_QUERY = gql`
  query Query($smartContractId: ID!) {
    getJobRefIdBySmartContractId(smartContractId: $smartContractId) {
      jobRefId
    }
  }
`;

export interface GetJobRefIdBySmartContractIdResponse {
  getJobRefIdBySmartContractId: {
    jobRefId: string;
  };
}

export interface GetJobRefIdBySmartContractIdVariables {
  smartContractId: string;
}
